import * as actions from '../redux/actions';

/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect } from 'react';

import HomeBanners from '../HomeBanners';
import ThemeSevenBanner from './common/ThemeSevenBanner';
import { ThemeSevenSearchBox } from '..';
import ThemeSevenSlider from './common/ThemeSevenSlider';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getSlides from '../functions/getSlides/getSlides';

const ThemeSeven = ({ history, operator }) => {
	useEffect(() => {
		const scriptTag = document.createElement('script');
		scriptTag.src = 'https://apps.elfsight.com/p/platform.js';
		scriptTag.async = true;

		document.body.appendChild(scriptTag);
		return () => {
			document.body.removeChild(scriptTag);
		};
	}, []);

	return (
		<div className="theme-seven">
			<div style={{ position: 'relative' }}>
				<HomeBanners
					slides={getSlides('Banner', operator)}
					height={'100vh'}
					activeDotColor={operator && operator.color_codes && operator.color_codes.button_color}
				/>
				<div className="searchboxoverlay">
					<ThemeSevenSearchBox history={history} operator={operator} />
				</div>
			</div>
			<ThemeSevenBanner topBanner />
			<ThemeSevenSlider slides={getSlides('Destination', operator)} destinoTitle />
			<ThemeSevenBanner bottomBanner />
			<div className="feeds">
				<div className="new-container d-flex">
					<div className="col-md-6 text-center">
						{/* need to upgrade plan*/}
						<div class="elfsight-app-635e82cb-8b65-45bc-851a-b004eb236553"></div>
					</div>
					<div className="col-md-6 text-center">
						<iframe
							src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fbusesfernandez1947%2F&tabs=timeline&width=500&height=300&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
							width="500"
							height="300"
							style={{ border: 'none', overflow: 'hidden' }}
							scrolling="no"
							frameborder="0"
							allowfullscreen="true"
							allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
						></iframe>
					</div>
				</div>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeSeven);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/ThemeSeven.js